import { gql } from 'apollo-boost';

export const SignInOwner = gql`
  mutation SignInOwner($ownerId: String!, $ownerPwd: String!) {
    signInOwner(ownerId: $ownerId, ownerPwd: $ownerPwd) {
      token
      owner {
        ownerNo
        ownerId
        mobile
        ceoName
        zipCd
        addr
        addrDtl
        roadAddr
        roadAddrDtl
        roadZipCd
        gradeCd
        stts
        regCh
        regId
        regDtm
        modId
        modDtm
      }
    }
  }
`;

export const ShopWithOwnerId = gql`
  query ShopWithOwnerId($ownerId: String!) {
    shopWithOwnerId(ownerId: $ownerId) {
      shopId
      shopTitle
    }
  }
`;
